
import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from "sweetalert2"
import Breadcrums from '../../../components/company_panel/common/breadcrumbs';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AddMeals, getAllMenuItems } from '../../../services/company_panel/mealService';
import { capitalizeAllFirstLetters, companyDetail, getBrandId, getCompany, removeModalBackdrops } from '../../../helpers/commonFunctions'
import defaultImage from '../../../assets/company/img/default_img.png';
import { IMG_MAX_SIZE, SUPPORTED_FORMATS, FILE_SLUGS, UPLOAD_DIRS } from '../../../utils/Constants';
import { GetGCPSignedUploadUrl } from '../../../services/commonService';
import { GetAllActiveTaxes } from '../../../services/company_panel/setting/taxConfigurationService';
import CustomDatetimepicker from '../../../helpers/customDatepicker';
import CustomMultiSelect from '../../../components/common/CustomMultiSelect';
import { GetBrandOutletsList } from '../../../services/company_panel/outletService';
// import Select from "react-select";
import { Dropdown } from 'semantic-ui-react';

const CreateMealsCombos = () => {

    // page the user was on in the list (carried in the route) so we return there
    const params = useParams();
    const listPage = params?.pgno || 1;
    const breadcrumbs = [
        {
            title: "Meals/Combos",
            url: `/company/menu/menu/meals_combos/list/${listPage}`
        },
        {
            title: "Create Meal",
            url: ""
        },
    ];
    const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [browseItemData, setBrowseItemData] = useState([]);
    const [filterBrowseItemData, setFilterBrowseItemData] = useState([]);
    const [searchInput, setSearchInput] = useState(""); // Add search input state
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [currentBrand, setCurrentBrand] = useState(getBrandId());
    const [taxList, setTaxList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [selectedMenuItem, setSelectedMenuItem] = useState([]);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        if (currentBrand != getBrandId()) {
            navigate(`/company/menu/menu/meals_combos/list/${listPage}`);
        }
    });

    useEffect(() => {
        return () => {
            removeModalBackdrops();
        }
    }, []);

    useEffect(() => {
        GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) }).then(data => {
            setOutletList(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [isBrandChanged]);

    const outletListData = outletList.map((item) => ({
        label: `${capitalizeAllFirstLetters(item?.outlet_name)}${item?.short_code ? ` (${item.short_code})` : ''}`,
        value: item?.id,
    }));

    useEffect(() => {
        const formData = new FormData()
        formData.append('brand_id', getBrandId());
        formData.append('type', 'tax-groups');
        GetAllActiveTaxes(formData).then(data => {
            setTaxList(data && data.data && data.data.response ? data.data.response : [])
        }).catch(error => {
            console.log("error ====> ", error);
        })
    }, [isBrandChanged]);

    useEffect(() => {
        getAllMenuItems({ brand_id: getBrandId() }).then(data => {
            if (data && data.data && data.data.response) {
                // setBrowseItemData(data.data.response.rows);
                const menuItemOptions = data.data.response.rows?.map(item => ({...item, value: item.id, label: item.item_name}));
                setBrowseItemData(menuItemOptions);
            }
        }).catch(error => {
            console.log("error=====>", error);
        });
    }, [isBrandChanged]);



    const [currentIndex, setCurrentIndex] = useState(null);
    const IMG_MAX_SIZE = 5 * 1024 * 1024;

    const validateSchema = Yup.object().shape({
        logo: Yup.mixed()
            .required('Image is required')
            .test(
                'fileSize',
                `Image size exceeds the maximum limit of 5 MB`,
                (value) => value && value.size <= IMG_MAX_SIZE
            ),
        name: Yup.string()
            .required('Brand name is required')
            .max(30, 'Brand name should not exceed 30 characters'),
        price: Yup.number()
            .required('Price is required')
            .positive('Price must be a positive number'),
            // .integer('Price must be an integer'),
        name_ar: Yup.string()
            .required('Brand name (Arabic) is required')
            .max(30, 'Brand name (Arabic) should not exceed 30 characters'),
        description: Yup.string().trim().max(250, 'Description should not exceed 250 characters'),
        description_ar: Yup.string().trim().max(250, 'Description (Arabic) should not exceed 250 characters'),
        start_date: Yup.date().nullable().required('Start date is required'),
        end_date: Yup.date().nullable().required('End date is required')
            .min(Yup.ref('start_date'), 'End date cannot be before start date'),
        start_time: Yup.string().required('Start time is required'),
        end_time: Yup.string().required('End time is required'),
        items: Yup.array()
            .of(Yup.object().shape({
                item_type: Yup.string()
                    .required('Item Type is required')
                    .max(20, 'Item Type cannot be longer than 20 characters'),
                quantity: Yup.number()
                    .required('Quantity is required')
                    .positive('Quantity must be a positive number')
                    .integer('Quantity must be an integer'),
                subItems: Yup.array().min(1, "Browse Items Cannot be Empty")
            })
            )
            .test('has-errors', 'Invalid social media data', function (items) {
                return items && items.some(item => {
                    return Object.keys(item).some(key => item[key] !== undefined);
                });
            }),
    });



    const startOfDay = (date) => {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);  // Set time to the start of the day 00:00:00.000
        return newDate;
    };

    const endOfDay = (date) => {
        const newDate = new Date(date);
        newDate.setHours(23, 59, 59, 999);  // Set time to the end of the day 23:59:59.999
        return newDate;
    };

    const formik = useFormik({
        initialValues: {
            logo: '',
            name: '',
            name_ar: '',
            price: '',
            tax_group_id : '',
            description: '',
            description_ar: '',
            outlet_ids: [],
            start_date: '',
            end_date: '',
            start_time: '',
            end_time: '',
            items: [{ item_type: '', quantity: '', subItems: [] }],
        },
        validationSchema: validateSchema,
        onSubmit: async (values) => {
            try {
                const company_id = getCompany().company_id;
                const company_register_id = companyDetail().company_id;

                const formData = new FormData();
                formData.append("name", values.name);
                formData.append("name_ar", values.name_ar);
                formData.append("price", values.price);
                formData.append("tax_group_id", values.tax_group_id);
                formData.append("description", values.description);
                formData.append("description_ar", values.description_ar);
                formData.append("outlet_ids", JSON.stringify(values.outlet_ids || []));
                formData.append("start_date", values.start_date ? startOfDay(values.start_date).toISOString() : '');
                formData.append("end_date", values.end_date ? endOfDay(values.end_date).toISOString() : '');
                formData.append("start_time", values.start_time || '');
                formData.append("end_time", values.end_time || '');
                formData.append("brand_id", getBrandId());
                formData.append('company_id', company_id);
                const transformedItems = values.items.map(item => ({
                    item_type: item.item_type,
                    quantity: item.quantity,
                    menuItems: item.subItems
                }));
                formData.append("items", JSON.stringify(transformedItems));

                let filenameUploaded;
                if (values.logo instanceof File) {
                    try {
                        const logoSignedRes = await GetGCPSignedUploadUrl({
                            original_name: values.logo.name,
                            file_prefix: FILE_SLUGS.MENU_MEAL_COMBO_LOGO,
                            mime_type: values.logo.type,
                            folder: `company-id-${company_register_id}/brand-id-${getBrandId()}/${UPLOAD_DIRS.MENU_MEAL_COMBO_LOGO}`,
                        });
                        const { signedUrl, filename } = logoSignedRes?.data?.response;
                        await fetch(signedUrl, {
                            method: 'PUT',
                            headers: { 'Content-Type': values.logo.type },
                            body: values.logo,
                        });
                        filenameUploaded = filename;
                    } catch (uploadError) {
                        console.log("Media upload error ====> ", uploadError);
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'error',
                            title: 'Something went wrong. Please try again.',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true,
                            position: 'top-right',
                        });
                    }
                }
                if (filenameUploaded) {
                    formData.append('logo', filenameUploaded);
                }

                const response = await AddMeals(formData);
                if (response.data.status === 1 || response.data.status === '1') {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'success',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500,
                        toast: true,
                        position: 'top-right',
                    });
                    setTimeout(() => {
                        navigate(`/company/menu/menu/meals_combos/list/${listPage}`);
                    }, 1000);
                } else {
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 5000,
                        toast: true,
                        position: 'top-right',
                    });
                }
            } catch (error) {
                console.log("error ====> ", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.response?.data?.message || 'Something went wrong. Please try again.',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                });
            }
        }
    })


    const handleAdd = () => {
        formik.setFieldValue('items', [
            ...formik.values.items,
            { item_type: '', quantity: '', subItems: [] },
        ]);
    };


    const handleRemove = (index) => {
        formik.setFieldValue(
            'items',
            formik.values.items.filter((_, i) => i !== index)
        );
    };

    // const handelChange = (event, index) => {
    //     let data = [...filterBrowseItemData];
    //     // data[index].checked = event.target.checked;
    //     data[index].checked = !data[index].checked
    //     setFilterBrowseItemData(data);
    // };

    const initBrowseItem = (index) => {
        setCurrentIndex(index);
        setSelectedMenuItem([]);
        // const subItems = formik?.values?.items[index].subItems;
        // let data = browseItemData.map((item) => {
        //     return {
        //         ...item, checked: Boolean(subItems.filter(a => a.id == item.id)[0])
        //     };
        // });
        // // setBrowseItemData(data);
        // setFilterBrowseItemData(data);
    };

    // console.log(filterBrowseItemData, '--------filter browse items');

    // What is still addable to the group the modal was opened from.
    const browseItemOptions = browseItemData.filter(item => currentIndex === null
        || !(formik.values.items[currentIndex]?.subItems || []).some(subItem => subItem.id == item.value));

    const addBrowseItems = () => {
        const menuItems = browseItemData.filter(item => (selectedMenuItem || []).includes(item.value));

        let allValues = [...formik.values.items];
        if (currentIndex !== null && menuItems.length) {
            const existingIds = allValues[currentIndex].subItems.map(subItem => subItem.id);
            menuItems.forEach(menuItem => {
                // The dropdown already hides what is in the group, but a stale
                // selection should never duplicate a row.
                if (existingIds.includes(menuItem.id)) return;
                allValues[currentIndex].subItems.push({
                    id: menuItem.id,
                    item_name: menuItem.item_name,
                    item_name_ar: menuItem.item_name_ar,
                    price: menuItem.default_price
                });
            });
            formik.setFieldValue('items', allValues);
        }
        setSelectedMenuItem([]);
    };

    const deleteSubItem = (parentIndex, i) => {
        let allValues = [...formik.values.items];
        allValues[parentIndex].subItems.splice(i, 1);
        formik.setFieldValue('items', allValues);
    };
    // const filteredBrowseItems = browseItemData.filter(item =>
    //     item?.item_name?.toLowerCase().includes(searchInput?.toLowerCase())
    // );
    // const disabledItemIds = formik.values.items.flatMap(item =>
    //     item.subItems.map(subItem => subItem.id)
    // );
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreviewImage(URL.createObjectURL(file));
        } else {
            // If no file is selected, keep the previous image
            setPreviewImage(defaultImage);
        }
    };

    const handleFileClick = () => {
        // Clear the file input value
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };
    return (
        <>
            <div className="page-header d-flex align-items-center">
                <div className="page-header-left">
                    <h4>Meals/Combos</h4>
                    <Breadcrums data={breadcrumbs} />
                </div>
                <div className="page-header-right ms-auto">

                </div>
            </div>

            <form onSubmit={formik.handleSubmit}>
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="row row-sm">
                            <div className='col-md-12'>
                                <div className='upload-logo d-flex align-items-center gap-3 mb-3'>
                                    <div className="avatar avatar-xl">

                                        {previewImage ?

                                            <img alt="avatar" src={previewImage} className={previewImage ? "" : "d-none"} />
                                            :
                                            <img alt="avatar" src={defaultImage} />
                                        }

                                    </div>
                                    <div className='btn btn-black btn-file-type'>Upload logo <input id="logo" onClick={handleFileClick} name="logo" accept="image/*" type="file" onChange={(event) => {
                                        formik.setFieldValue("logo", event.currentTarget.files[0] || "");
                                        { event.currentTarget.files.length == 1 ? (setPreviewImage(URL.createObjectURL(event.currentTarget.files[0]))) : (setPreviewImage("")) }
                                    }}
                                    /></div>
                                </div>
                                <span className='text-danger d-flex text-left' id='errortext'>
                                    {formik.errors.logo && formik.touched.logo && formik.errors.logo}
                                </span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='name' className='text-left d-flex'>Name<span className="requirestar">*</span></label>
                                <input name='name' id="name" type='text' placeholder='Enter Name' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name} className='form-control' />
                                <span className='text-danger d-flex text-left'>{formik.errors.name && formik.touched.name && formik.errors.name}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='name_ar' className='text-left d-flex'>Name (arabic)<span className="requirestar">*</span></label>
                                <input name='name_ar' id="name_ar" type='text' placeholder='Enter Name (arabic)' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name_ar} className='form-control' />
                                <span className='text-danger d-flex text-left'>{formik.errors.name_ar && formik.touched.name_ar && formik.errors.name_ar}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='price' className='text-left d-flex'>Price<span className="requirestar">*</span></label>
                                <input name='price' id="price" type='number' placeholder='Enter Price' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.price} className='form-control' />
                                <span className='text-danger d-flex text-left'>{formik.errors.price && formik.touched.price && formik.errors.price}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='tax_group_id' className='d-flex'>Tax Group :</label>
                                <select id="tax_group_id" className='form-control' name='tax_group_id' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.tax_group_id}>

                                    <option value="">Select Tax Group</option>
                                    {taxList?.length ? taxList?.map((row) => (
                                        <option key={row.id} value={row.id}>{row?.name}</option>
                                    )) : ''}
                                </select>
                                <span className='text-danger d-flex'>{formik.errors.tax_group_id && formik.touched.tax_group_id && formik.errors.tax_group_id}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='outlet_ids' className='text-left d-flex'>Outlets</label>
                                <CustomMultiSelect data={outletListData} overFlowVisibleOptions={1} form={formik} name='outlet_ids' />
                                <span className='text-danger d-flex text-left'>{formik.errors.outlet_ids && formik.touched.outlet_ids && formik.errors.outlet_ids}</span>
                            </div>
                            {/* keeps Outlets alone on its row so the date/time fields stay paired */}
                            <div className='col-lg-6 form-group mb-3'></div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='start_date' className='text-left d-flex'>Start Date <span className="requirestar">*</span></label>
                                <CustomDatetimepicker
                                    placeholder={"YYYY-MM-DD"}
                                    setField={formik.setFieldValue}
                                    fieldname={`start_date`}
                                    setFieldTouched={formik.setFieldTouched}
                                    value={formik.values.start_date}
                                />
                                <span className='text-danger d-flex text-left'>{formik.errors.start_date && formik.touched.start_date && formik.errors.start_date}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='end_date' className='text-left d-flex'>End Date <span className="requirestar">*</span></label>
                                <CustomDatetimepicker
                                    placeholder={"YYYY-MM-DD"}
                                    setField={formik.setFieldValue}
                                    fieldname={`end_date`}
                                    setFieldTouched={formik.setFieldTouched}
                                    value={formik.values.end_date}
                                />
                                <span className='text-danger d-flex text-left'>{formik.errors.end_date && formik.touched.end_date && formik.errors.end_date}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='start_time' className='text-left d-flex'>Start Time <span className="requirestar">*</span></label>
                                <input
                                    name="start_time"
                                    id="start_time"
                                    placeholder={"Select"}
                                    value={formik.values.start_time}
                                    type="time"
                                    className='form-control cp'
                                    onChange={(e) => { formik.setFieldValue("start_time", e?.target?.value) }}
                                    onBlur={formik.handleBlur}
                                />
                                <span className='text-danger d-flex text-left'>{formik.errors.start_time && formik.touched.start_time && formik.errors.start_time}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group mb-3'>
                                <label htmlFor='end_time' className='text-left d-flex'>End Time <span className="requirestar">*</span></label>
                                <input
                                    name="end_time"
                                    id="end_time"
                                    placeholder={"Select"}
                                    value={formik.values.end_time}
                                    type="time"
                                    className='form-control cp'
                                    onChange={(e) => { formik.setFieldValue("end_time", e?.target?.value) }}
                                    onBlur={formik.handleBlur}
                                />
                                <span className='text-danger d-flex text-left'>{formik.errors.end_time && formik.touched.end_time && formik.errors.end_time}</span>
                            </div>
                            {/* <div className='col-lg-6 text-center form-group mb-3'></div> */}
                            <div className='col-lg-6 text-center form-group required mb-3'>
                                <label htmlFor='description' className='text-left d-flex'>Description </label>
                                <textarea name='description' id="description" rows="2" type='text' placeholder='Enter Description' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.description} className='form-control' style={{ height: "100px" }} />
                                <span className='text-danger d-flex text-left'>{formik.errors.description && formik.touched.description && formik.errors.description}</span>
                            </div>
                            <div className='col-lg-6 text-center form-group required mb-3'>
                                <label htmlFor='description_ar' className='text-left d-flex'>Description (arabic)</label>
                                <textarea name='description_ar' id="description_ar" rows="2" type='text' placeholder='Enter Description (arabic)' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.description_ar} className='form-control' style={{ height: "100px" }} />
                                <span className='text-danger d-flex text-left'>{formik.errors.description_ar && formik.touched.description_ar && formik.errors.description_ar}</span>
                            </div>

                            <div className="combo-section-head">
                                <h5>Items</h5>
                                <span>Group the menu items that make up this combo</span>
                            </div>
                            {formik.values.items.map((item, index) => (
                                <div className="combo-item-card" key={index}>
                                    <div className="combo-item-head">
                                        <span className="combo-item-badge">Group {index + 1}</span>
                                        {formik.values.items.length > 1 &&
                                            <button type="button" className="combo-item-remove" onClick={() => handleRemove(index)}>
                                                <i className="ti ti-trash"></i> Remove
                                            </button>
                                        }
                                    </div>
                                    <div className="row">
                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor={`items[${index}].item_type`} className='text-left d-flex'>Item Type<span className="requirestar">*</span></label>
                                            <input name={`items[${index}].item_type`} id={`items[${index}].item_type`} type='text' placeholder='Enter Item Type' onChange={formik.handleChange} onBlur={formik.handleBlur} value={item.item_type} className='form-control' />
                                            {formik.touched.items && formik.touched.items[index] && formik.errors.items && formik.errors.items[index] && formik.errors.items[index].item_type ? (
                                                <div className="text-danger d-flex text-left">{formik.errors.items[index].item_type}</div>
                                            ) : null}
                                        </div>
                                        <div className='col-lg-6 text-center form-group mb-3'>
                                            <label htmlFor={`items[${index}].quantity`} className='text-left d-flex'>Quantity<span className="requirestar">*</span></label>
                                            <input name={`items[${index}].quantity`} id={`items[${index}].quantity`} type='number' placeholder='Enter Quantity' onChange={formik.handleChange} onBlur={formik.handleBlur} value={item.quantity} className='form-control' />
                                            {formik.touched.items && formik.touched.items[index] && formik.errors.items && formik.errors.items[index] && formik.errors.items[index].quantity ? (
                                                <div className="text-danger d-flex text-left">{formik.errors.items[index].quantity}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className='combo-item-browse'>
                                        <a className='combo-browse-btn' data-bs-toggle="modal" data-bs-target="#addCardModal" href='#addCardModal' onClick={() => initBrowseItem(index)}>
                                            <i className='ti ti-plus'></i> Browse Items
                                        </a>
                                        {formik.touched.items && formik.touched.items[index] && formik.errors.items && formik.errors.items[index] && formik.errors.items[index].subItems ? (
                                            <div className="text-danger">{formik.errors.items[index].subItems}</div>
                                        ) : null}
                                    </div>
                                    {
                                        item?.subItems?.length ?
                                            <div className="combo-subitems">
                                                <div className="combo-subitems-head">
                                                    Menu Items <span className="combo-subitems-count">{item?.subItems?.length}</span>
                                                </div>
                                                <table className="table table-custom mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th width="55%">Item</th>
                                                            <th width="30%">Price</th>
                                                            <th width="15%" className='text-end'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            item?.subItems.map((subItem, i) => (
                                                                <tr key={i}>
                                                                    <td>{capitalizeAllFirstLetters(subItem?.item_name)}</td>
                                                                    <td>
                                                                        <span className="combo-price">
                                                                            <span>SAR</span>
                                                                            <input type="number" name={`items[${index}].subItems[${i}].price`}
                                                                                value={subItem?.price} onChange={formik.handleChange} className="form-control" />
                                                                        </span>
                                                                    </td>
                                                                    <td className='text-end'>
                                                                        <button type="button" className="combo-subitem-delete" onClick={() => deleteSubItem(index, i)} aria-label="Remove item">
                                                                            <i className="ti ti-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            : null
                                    }
                                </div>
                            ))}
                            <div className="combo-add-more">
                                <button type="button" onClick={handleAdd}>
                                    <i className="ti ti-plus"></i> Add more
                                </button>
                            </div>
                            <div className="combo-actions">
                                <button className="btn btn-primary" type="submit" disabled={submitted ? true : null}>
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            {/*Modal */}
            {/* <div className="modal fade" id="addCardModal" aria-labelledby="addCardModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title" id="addCardModalLabel">Browse Items</h2>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        {filteredBrowseItems && filteredBrowseItems.length > 0 && filteredBrowseItems.map((item, i) => (
                                            <div key={i} className="col-12 d-flex justify-content-between align-items-center py-2">
                                                <span>{capitalizeAllFirstLetters(item.item_name)}</span>
                                                <input type="checkbox" checked={item?.checked} className="form-check-input" onChange={(event) => handelChange(event, i)} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-dark" style={{ width: '48%' }} data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                            <button type="submit" className="btn btn-primary" style={{ width: '48%' }} data-bs-dismiss="modal" aria-label="Close" onClick={addBrowseItems}>Add</button>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="modal fade" id="addCardModal" aria-labelledby="addCardModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title" id="addCardModalLabel">Browse Items</h2>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setSelectedMenuItem([])}></button>
                        </div>
                        <div className="modal-body">
                            {browseItemData && browseItemData.length > 0 ? (
                                <>
                                    {/* <div className="form-group">
                                        <input type="text" className="form-control" placeholder="Search here" value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)} />
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row">
                                                {filterBrowseItemData.map((item, i) => (
                                                    
                                                    <div
                                                        key={i}
                                                        className="col-12 d-flex justify-content-between align-items-center py-2"
                                                        style={{
                                                            // position: disabledItemIds.includes(item.id) ? 'absolute' : 'static',
                                                            // visibility: disabledItemIds.includes(item.id) ? 'hidden' : 'visible',
                                                            width: '100%', // Ensures the hidden item takes up the full width but is not visible
                                                            height: 'auto' // Ensures proper height if needed
                                                        }}
                                                    >
                                                        {console.log('-------item', item.item_name, item.checked)}
                                                        <span>{capitalizeAllFirstLetters(item?.item_name)}</span>
                                                        <input
                                                            type="checkbox"
                                                            checked={item?.checked}
                                                            className="form-check-input"
                                                            onChange={(event) => handelChange(event, i)}
                                                        />
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div> */}
                                    {/* <Select
                                        options={browseItemData}
                                        value={browseItemData.find((opt) => opt.value === selectedMenuItem) || null}
                                        onChange={(option) => setSelectedMenuItem(option.value)}
                                        placeholder="Select Menu Item"
                                        isSearchable={true}   // 🔍 search enabled
                                        className="cursor-pointer" // whole dropdown shows pointer
                                        filterOption={(option, rawInput) => {
                                            const input = rawInput.toLowerCase();
                                            return (
                                                option.label.toLowerCase().includes(input) ||
                                                String(option.value).toLowerCase().includes(input)
                                            );
                                        }}
                                    /> */}
                                    {/* Multi select: several items can be picked and added to the group in one go */}
                                    <Dropdown
                                        placeholder="Select menu items"
                                        fluid
                                        multiple
                                        search
                                        selection
                                        options={browseItemOptions.map(item => ({
                                            key: item.value,
                                            text: item.label,
                                            value: item.value,
                                        }))}
                                        value={selectedMenuItem || []}
                                        onChange={(e, { value }) => setSelectedMenuItem(value)}
                                    />
                                    {browseItemOptions.length === 0 ?
                                        <div className='text-muted mt-2'>Every menu item is already added to this group.</div> : null}
                                </>
                            ) : (
                                <div className="alert alert-warning" data-bs-dismiss="modal">
                                    There is no menu item created yet. Please{' '}
                                    <Link to="/company/menu/menu/menu_items/add">
                                        create a menu item
                                    </Link>{' '}
                                    to browse items.
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-dark" style={{ width: '48%' }} data-bs-dismiss="modal" aria-label="Close" onClick={() => setSelectedMenuItem([])}>Cancel</button>
                            {browseItemData && browseItemData.length > 0 && (
                                <button type="submit" className="btn btn-primary" style={{ width: '48%' }} data-bs-dismiss="modal" aria-label="Close" onClick={addBrowseItems}>Add</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
        </>
    );
}

export default CreateMealsCombos;